
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type interchangesTabRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function interchangesTabRT(): TemplateResult<interchangesTabRTRootProps> {
    return this.productData.length ? _createElement('span', { 'key': '0' }, 'INTERCHANGE') : null;
}
        export const componentNames = []